import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 85,
	height: 85,
	viewBox: "0 0 85 85",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2886_152101)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M69.4226 66.9756H15.8131C15.034 66.9756 14.4023 67.6085 14.4023 68.3893C14.4023 69.1701 15.034 69.803 15.8131 69.803H69.4226C70.2018 69.803 70.8334 69.1701 70.8334 68.3893C70.8334 67.6085 70.2018 66.9756 69.4226 66.9756Z",
				fill: "#1A8EF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.8033 51.6368H31.9416C32.4848 51.6368 32.9264 52.0793 32.9264 52.6236V66.977H18.8186V52.6236C18.8186 52.0793 19.2602 51.6368 19.8033 51.6368Z",
				fill: "#00ABFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.8774 39.6699H48.3583C49.0834 39.6699 49.6717 40.2594 49.6717 40.9861V66.977H35.564V40.9861C35.564 40.2594 36.1523 39.6699 36.8774 39.6699Z",
				fill: "#94DCFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.8614 28.8438H64.8655C65.7218 28.8438 66.4173 29.5407 66.4173 30.3988V66.9756H52.3096V30.3988C52.3096 29.5407 53.0051 28.8438 53.8614 28.8438Z",
				fill: "#00ABFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.7571 38.1147L21.3298 45.8172C24.2551 47.9853 27.8708 49.2686 31.7793 49.2686V39.8419C29.8873 39.8419 28.1454 39.1958 26.7556 38.1147H26.7571Z",
				fill: "#1A8EF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.1667 31.6194C14.1667 37.4335 16.9874 42.5999 21.3298 45.8171L26.7571 38.1147C24.8226 36.6094 23.5739 34.2589 23.5739 31.6194C23.5739 27.9232 26.0197 24.7897 29.3759 23.7573C29.6323 23.6782 29.8083 23.4441 29.8083 23.1765V14.7761C29.8083 14.4052 29.4791 14.1178 29.1119 14.174C20.6607 15.4664 14.1667 22.7964 14.1667 31.6194Z",
				fill: "#00ABFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.2047 33.5961C39.9376 33.5961 39.704 33.7724 39.6251 34.0294C38.5948 37.391 35.4677 39.8435 31.7808 39.8435V49.2701C40.5855 49.2701 47.9003 42.7627 49.19 34.2939C49.2461 33.9275 48.9593 33.5961 48.5891 33.5961H40.2062H40.2047Z",
				fill: "#1A8EF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.2047 29.643H48.5876C48.9594 29.643 49.2446 29.3115 49.1885 28.9436C48.0323 21.3506 42.0284 15.3327 34.4497 14.1742C34.0825 14.1179 33.7517 14.4053 33.7517 14.7763V23.1781C33.7517 23.4457 33.9277 23.6799 34.1826 23.7589C36.7772 24.5572 38.8285 26.6112 39.6251 29.2112C39.704 29.4666 39.9376 29.643 40.2047 29.643Z",
				fill: "#94DCFF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2886_152101",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 56.6667,
			height: 56.6667,
			fill: "white",
			transform: "translate(14.1667 14.1666)"
		})
	}) })]
});
export default SvgIconReport;
